import compose from 'recompose/compose';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EventEmitter } from 'events';
import ReactModal from 'react-modal';
import { t } from '../../../../../modules/infra/i18n';

import AppointmentForm from '../../appointmentForm/appointmentFormContainer';
import withCanViewAppointments from '../../../../common/hoc/withCanViewAppointments';

class AppointmentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appointment: null,
      opened: false,
    };
  }

  componentDidMount() {
    if (!this.props.canViewAppointments) return;

    EventEmitter.prototype.on('appointment-clicked', this.updateProps);
    EventEmitter.prototype.on('open-appointment-modal', this.openModal);
    EventEmitter.prototype.on('close-appointment-modal', this.closeModal);
  }

  componentWillUnmount() {
    if (!this.props.canViewAppointments) return;

    EventEmitter.prototype.removeListener('appointment-clicked', this.updateProps);
    EventEmitter.prototype.removeListener('open-appointment-modal', this.openModal);
    EventEmitter.prototype.removeListener('close-appointment-modal', this.closeModal);
  }

  updateProps = (appointment) => {
    this.setState({ appointment, opened: true });
  };

  openModal = (type) => {
    if (type === 'details') {
      this.setState({
        opened: true,
      });
    }
  };

  closeModal = (type) => {
    if (type === 'details') {
      this.setState({
        opened: false,
      });
    }
  };

  render() {
    return (
      <ReactModal
        className={{
          base: 'remodal remodal-is-initialized remodal-is-opening u-animation-fill-mode-none',
          afterOpen: 'remodal-is-opened',
          beforeClose: 'remodal-is-closing',
        }}
        overlayClassName={{
          base: 'remodal-overlay remodal-wrapper remodal-is-initialized remodal-is-opening u-animation-fill-mode-none',
          afterOpen: 'remodal-is-opened',
          beforeClose: 'remodal-is-closing',
        }}
        closeTimeoutMS={150}
        onRequestClose={() => this.closeModal('details')}
        contentLabel={t('appointment:modal.content_label')}
        shouldCloseOnOverlayClick
        isOpen={this.state.opened}
        ariaHideApp={false}
      >
        <AppointmentForm edit appointment={this.state.appointment} />
      </ReactModal>
    );
  }
}
AppointmentDetails.propTypes = {
  canViewAppointments: PropTypes.bool.isRequired,
};

export default compose(withCanViewAppointments)(AppointmentDetails);
